import NetworkingOperations from "../index";

const PaypalLoginComplete = (data) => {
	const url = process.env.REACT_APP_PAYPAL_LOGIN_COMPLETE;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaypalLoginComplete;
